export const getLocationPayload = ({
  type,
  internalName,
  publicName,
  line1,
  line2,
  houseNumber,
  country,
  province,
  locality,
  postalCode,
  phone,
  phonePrefix,
  inventoryLocationId,
  defaultPackagingId,
}) => {
  return {
    type,
    internal_name: internalName,
    public_name: publicName,
    address: {
      line_1: line1,
      line_2: line2,
      house_number: houseNumber,
      locality,
      postcode: postalCode,
      country: country,
      province: province,
      phone: { prefix: phonePrefix, number: phone },
    },
    inventory_location_id: inventoryLocationId || null,
    default_packaging_id: defaultPackagingId || null,
  }
}

export const getUsedInventoryLocationIds = (locations = [], currentLocationId) => {
  return locations
    .filter(loc => loc.id !== currentLocationId && loc.inventory_location_id)
    .map(loc => loc.inventory_location_id)
}

export const getMethodsUsedInLocation = (methods, locationMethodIds) => {
  return methods?.filter(method => locationMethodIds?.includes(method?.id))
}
